/**
 * @author Oleg Slobodksoi aka Kof
 * @class Logo
 * Logo view of EmotionHeader
 */

var $ = require('jquery');

module.exports = function (_super)
{
    this.tabElementId = 'eh-logo';

    var self = this;

    var d = _super.d,
        $eh = _super.$eh,
        $eheContent = _super.$eheContent;

    var $logoSection,
        $borderSection,
        $borderCheck,
        $optionsWrapper,
        $preview,
        $previewImg,
        $previewDelete,
        $fieldset,

        uploadedLogo = false,

        $uploadForm,
        $uploadField,
        $uploadInput,

        $posHorSlider,
        $posVertSlider,
        $colorPicker,
        optionControlMapper = {},
        timeout;

    var sliderIds = {
        logoZoom: '#eh-logo-size-slider',
        logoHorPos: '#eh-logo-position-hor-slider',
        logoVertPos: '#eh-logo-position-vert-slider',
        logoPadding: '#eh-logo-border-padding-slider',
        logoBorderSize: '#eh-logo-border-width-slider'
    };

    this.model = _super.model;


    this.init = function()
    {
        this.viewWrapper.actionController(this, {events: 'click slidechange slide slidestart colorchange'});
        this.initElements();
        this.initUpload();
        this.initSliders();
        this.initFieldsets();
        this.initPickers();
        this.initAltTag();
        this.createTabs();
        // XXX Bugfix DHDIY-20287 
        // For some very strage reasons click handler on help link
        // won't work in Logo tab in some conditions in IE11 (IE is back in business !!!)
        // the workaround is to bind the mousedown
        _super.$eheHelp.bind('mousedown', function(e){
            cms.help.GuidedAssistant._instance._onModuleHelpLinkClick(e);
        });
    };
    this.onUploadedLogo = function()
    {
        _super.uploadedLogo = true;
        $(document.body).trigger('LogoUploaded.BSA');
    }
    this.initUpload = function()
    {
        var that = this;

        // attach the form upload behavior
        $uploadForm.xWebForms({

            beforeSend: function() {
                _super.loading(true);
                $eheContent.loadingBox().show();
                $uploadForm.diy_form('clearErrors');
            },

            success: function(jsonData) {
                var data = jsonData.data;
                _super.loading(false);
                $eheContent.loadingBox().hide();
                if (data.status == 'error') {
                	/* always trigger first the uploadError event.
                	 * if we trigger it after the error message, it will reset the field
                	 * and the error tooltip won't be visible */
                	$(this).trigger('uploadError');
                	/* show the error on the file upload field */
                	$uploadForm.diy_form("addError", data.message, $uploadField);
                    return;
                }
            	$(this).trigger('uploadSuccess');
              self.onUploadedLogo();
        	self.model.setLogoImageId(data.logoImageId);
        	self.model.setLogoUrl(data.src);
                self.model.setLogoDeleted(0);
                self.model.setLogoOriginalWidth(data.width);
                self.model.setLogoOriginalHeight(data.height);
                self.model.setLogoZoom(50);
                initSections(true);

                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Tried',
                    'name': 'Logo'
                });
            },

            complete: function() {
                _super.loading(false);
            	$eheContent.loadingBox().hide();
            }
        });

        $uploadForm.diy_form();
        CC.EmotionHeader.bind('hide', function() {
           $uploadForm.diy_form('clearErrors');
        });

        // trigger the upload on file selection
        $uploadField.diy_uploadField({
            change: function() {
                $uploadForm.submit();
            }
        });
    };

    this.initElements = function()
    {
        $logoSection = $('#eh-logo', $eheContent);
        $borderSection = $('#eh-logo-border-settings', $eheContent);
        $borderCheck = $('#eh-show-logo-border', $eheContent).diy_checkbox();
        $logoAltTag = $('#eh-logo-alttag', $eheContent);

        $optionsWrapper = $('.eh-logo-options-wrapper', $eheContent);

        $uploadForm = $('#eh-logo-upload-form', $eheContent);
        $uploadInput = $('input[type=file]', $uploadForm);
        $uploadField = $('#eh_logo_upload_field');

        $preview = $('#eh-logo-preview', $eheContent);
        $previewImg = $('img', $preview);
        $previewDelete = $('#eh-logo-delete', $eheContent);
        $fieldset = $('.fieldset#eh-logo', $eheContent);

        $previewDelete
            .addClass('ui-button-borderless')
            .button({
                icons: {
                    primary : "ui-icon-trash"
                },
                text: false
            })
            .click(function() {
            self.removeLogo();
        });

        $logoMaker = $('.eh-logo-maker', $eheContent).bind('click', function() {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                'pageName': 'Emotion Header Logo',
                'actionName': 'logoMakerHeader'
            });
        })
    };

    this.initFieldsets = function()
    {
        $logoSection.fieldset({ collapsed: true });
        $logoSection.bind('toggle.fieldset', function(e, show) {
            self.model.setLogoVisible(show ? 1 : 0);
            $(document).trigger('diy-eh-component-visibility-changed', {
                'componentName': 'logo',
                'show': show
            });
        });

        /*$borderSection.fieldset({ collapsed: true });
        $borderSection.bind('toggle.fieldset', function(e, show) {
            e.stopPropagation();
            self.model.setLogoBorderVisible(show ? 1 : 0);
        });*/
        $borderCheck.bind('change.checkbox', function() {
            var show = $(this).is(':checked'),
                tabs = self.viewWrapper.find('.eh-logo-content'),
                currentTabIndex = tabs.diy_simpleTabs('option', 'activeTabIndex');
            tabs.diy_simpleTabs('option', 'activeTabIndex', 
                    show ? 2 /* eh-borderlogo-section */ : 0 /* eh-logo-settings-section */); 
            self.model.setLogoBorderVisible(show ? 1 : 0);
        });
    };
    
    this.createTabs = function() {
        this.viewWrapper.find('.eh-logo-content').diy_simpleTabs({
            activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
        });
    }

    this.initSliders = function()
    {
        var elem, min, max, step, unit;

        for (var opt in sliderIds) {
            if (opt == 'logoZoom') {
                min = 10;
                max = 100;
            }
            else if (opt == 'logoBorderSize') {
                min = 0;
                max = 10;
            }
            else if (opt == 'logoPadding') {
                min = 0;
                max = 20;
            }
            else {
                min = 0;
                max = 100;
            }

            if (opt == 'logoHorPos' || opt == 'logoVertPos') {
                step = 0.01;
            }
            else {
                step = 1;
            }

            if (opt == 'logoPadding' || opt == 'logoBorderSize') {
                unit = function(value) { return value + 'px'; };
            }
            else {
                unit = function(value) { return value + '%'; };
            }

            var invertValue = opt === 'logoVertPos'
            _super.initSlider({option: opt, id: sliderIds[opt],
                min: min, max: max,
                step: step,
                formatter: unit
            }, optionControlMapper, this.model, invertValue);            
        }
    };

    this.initPickers = function()
    {
        $colorPicker = $('#eh-logo-border-color').colorPicker({
            mode: 'button',
            onColorAccept: this.borderColorHandler,
            onColorSelect: this.borderColorHandler
        });

        CC.EmotionHeader.bind('collapse', CC.EmotionHeader.toHandler(
            function(e, data, status) {
                if(status == 'ok') {
                    $colorPicker.saveColor();
                } else {
                    $colorPicker.abortColor();
                }
            })
        );
    };

    this.initAltTag = function()
    {
        $logoAltTag.bind('keyup', function () {
            self.model.set('logoAltTag', $logoAltTag.val());
        });
    };

    this.borderColorHandler = function(color) {
        self.model.setLogoBorderColor(color, undefined, {from: self});
    };

    this.removeLogo = function()
    {
        _super.uploadedLogo = false;
        self.model.setLogoDeleted(1);
        self.model.setLogoUrl(0);
        initSections(false);
    };

    this.destroy = function()
    {
        $colorPicker.remove();
        $('.ui-slider', $eheContent).diy_slider('destroy');
        $('.fieldset', $eheContent).each(function() {
            $(this).fieldset('destroy');
        });
    };

    this.updateView = function(model, data, changed, extra)
    {
        if (extra && extra.from == this) {
            return;
        }

        for (var option in changed) {
            var value = changed[option];
            switch (option) {
                case 'logoVisible':
                    $logoSection.fieldset('setCollapsed', !value);
                    initSections(value && !model.getLogoDeleted());
                    break;

                case 'logoBorderVisible':
                    $borderCheck.diy_checkbox('option', 'checked', value);
                    self.viewWrapper.find('[data-simpletab=".eh-borderlogo-section"]')
                        .css('visibility', value ? '' : 'hidden');
                    
                    break;

                case 'logoAltTag':
                    $logoAltTag.val(value);
                    break;

                case 'logoDeleted':
                    initSections(!value);
                    /*
                     * Bugfix DHDIY-20647
                     * When logoVisible = 0 and logoDeleted = 1
                     * (this should not happen, but if it happens...)
                     * there is no possibility to edit logo anymore
                     * So I will do additional check before disabling
                     */
                    $fieldset.fieldset(value && model.getLogoVisible() ? 'disable' : 'enable');
                    break;

                case 'logoUrl':
                    value && updatePreview(true);
                    break;

                case 'logoBorderColor':
                    $colorPicker.setColor('#' + value);
                    break;

                default:
                    if (option in sliderIds) {
                        optionControlMapper[option].setValue(value)
                    }
                    break;
            }
        }
    };
    this.onShow = function()
    {
        if (_super.logoPanelOpened != true) {
            $(document.body).trigger('LogoPanelOpened.BSA');
            _super.logoPanelOpened = true;
        }
    };

    function updatePreview(show)
    {
        if (show) {
            $previewImg.attr('src', self.model.getLogoUrl());
        }
        $('.diy-image-preview', $preview)[show ? 'removeClass' : 'addClass']('diy-image-preview-no-image');
    }

    function initSections(show)
    {
        show = show == true;
        $optionsWrapper.toggle(show);
        $preview.toggle(show);
        $previewDelete.toggle(show);
        updatePreview(show);
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Logo.js
 ** module id = 874
 ** module chunks = 0
 **/